
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias-recentes/[title]",
      function () {
        return require("private-next-pages/noticias-recentes/[title]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias-recentes/[title]"])
      });
    }
  